import { UUID } from "crypto";
import { GetPieceMovement } from "./PieceMovement/PieceMovementFactory";
import {
  Direction,
  IPiece,
  PieceMovement,
  PieceType,
  Position,
  IMove,
  ISquare,
} from "./types";
import { ZodiacFEN } from "./Fen/ZodiacFEN";

export class Piece implements IPiece {
  // not on the interface
  movementStrategy: PieceMovement;

  constructor(
    type: PieceType,
    isLight: boolean,
    direction: Direction | null = null
  ) {
    // Generate ID based on piece type and color
    const pieceChar = ZodiacFEN.getPieceChar(type);
    const pieceString = isLight
      ? pieceChar.toUpperCase()
      : pieceChar.toLowerCase();
    this.id = pieceString;

    this.type = type;
    this.isLight = isLight;
    this.movementStrategy = GetPieceMovement(this.type);

    this.isKing = false;
    this.isZombified = false;
    this.isFainted = false;
    this.isEntangled = false;
    this.isShadowed = false;
    this.isShadow = false;
    this.isZombieInkShadow = false;
    this.zombieInkTargetColor = undefined;
    this.isInfected = false;
    this.isMeadowed = false;
    this.isRiding = false;
    this.isHousing = false;
    this.isLone = false;
    this.isDormant = false;
    this.hasCharged = false;
    this.hasMoved = false;
    this.hasShed = false;
    this.hasLilyJumped = false;
    this.direction = direction;
    this.entangledPieceId = undefined;

    this.poisonedStatus = {
      removeOnTurn: undefined,
      isPoisoned: false,
    };
    this.zombifiedStatus = {
      isZombified: false,
      removeOnTurn: undefined,
    };
  }

  id: string;
  type: PieceType;
  isLight: boolean;
  isKing: boolean;
  poisonedStatus: { removeOnTurn?: number; isPoisoned: boolean };
  zombifiedStatus: { isZombified: boolean; removeOnTurn?: number };
  isZombified: boolean;
  isFainted: boolean;
  isEntangled: boolean;
  isShadowed: boolean;
  isShadow: boolean;
  isZombieInkShadow: boolean;
  zombieInkTargetColor?: boolean;
  isInfected: boolean;
  direction: Direction | null;
  hasCharged: boolean;
  hasMoved: boolean;
  hasShed: boolean;
  isMeadowed: boolean;
  isRiding: boolean;
  isHousing: boolean;
  isLone: boolean;
  isDormant: boolean;
  hasLilyJumped: boolean;
  entangledPieceId?: string;

  getValidMovesForPiece(
    board: ISquare[][],
    position: Position,
    isLightTurn?: boolean,
    gameStateManager?: any
  ): IMove[] {
    return this.movementStrategy.getValidMoves(
      this,
      position,
      board,
      isLightTurn,
      gameStateManager
    );
  }
}
